import React from 'react';
import { Header } from '../Header/Header';
import { Routes } from '../Routes/Routes';
import 'antd/dist/antd.css';
import classes from './Layout.module.scss';
import { MenuLayout } from '../Menu/MenuLayout';
import { connect } from 'react-redux';
import { initializeSelector } from '../../Redux/Reducers/settingsReducer';
import { initialize } from '../../Redux/Reducers/settingsReducer';
import Loader from 'react-loader-spinner';

interface StateProps {
  isInitialized: boolean
}
interface DispatchProps {
  initialize: () => void
}
interface Props extends StateProps, DispatchProps { }

function Layout(props: Props) {
  React.useEffect(() => {
    props.initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {
        props.isInitialized
          ? <>
            <Header />
            <div className={classes.Layout}>
              <MenuLayout />
              <Routes />
            </div>
          </>
          : <div>
            <Loader type='TailSpin' color='#000000' height={100} width={100} />
          </div>
      }

    </>
  );
}

function mapStateToProps(state: any) {
  return {
    isInitialized: initializeSelector(state)
  }
}
const mapDispatchToProps = {
  initialize
}

const ConnectedLayout = connect(mapStateToProps, mapDispatchToProps)(Layout);

export { ConnectedLayout as Layout };